import FormHandler from "./ahx-wcpl-ajax-form.js";

export default class CopyListHandler extends FormHandler {
    /* constructor(formElement) {
        super(formElement);

        //this.listsTable = document.getElementById("product_lists");

        // bind to the correct this which will be AddListHandler object
        // this.formElement?.addEventListener(
        //     "submit",
        //     this.onSubmitForm.bind(this)
        // );
    } */

    async submitForm(event) {
        
        let data = await super.submitForm(event);
        if ( data.list_url ) {
            window.location.href = data.list_url;
        }

    }

}
